if (!customElements.get('offer-three')) {
  customElements.define('offer-three', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        this.updateCalendar();
        this.timer = setInterval(() => this.updateCalendar(), 1000);
        return;
      }
      this.initialized = true;
      this.form = this.querySelector('[data-offer-form]');
      this.selects = [...this.querySelectorAll('[data-offer-select]')];
      this.button = this.querySelector('[data-offer-submit]');
      this.error = this.querySelector('[data-offer-error]');
      this.busy = false;
      this.start = Date.parse(this.dataset.start);
      this.end = Date.parse(this.dataset.end);
      /* Button, error and calendar texts come from the section settings (Shopify theme editor). */
      this.selects.forEach(select => select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const card = select.closest('.offer-three__choice');
        const image = card.querySelector('[data-offer-image]');
        const placeholder = card.querySelector('[data-offer-placeholder]');
        image.hidden = !option.dataset.image;
        placeholder.hidden = Boolean(option.dataset.image);
        if (option.dataset.image) {
          image.src = option.dataset.image;
          image.alt = option.dataset.name;
        } else {
          image.removeAttribute('src');
          image.alt = '';
        }
        this.error.textContent = '';
        this.updateCalendar();
      }));
      this.form.addEventListener('submit', event => this.submit(event));
      this.updateCalendar();
      this.timer = setInterval(() => this.updateCalendar(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    isActive() {
      const now = Date.now();
      return now >= this.start && now < this.end;
    }
    updateCalendar() {
      const active = this.isActive();
      this.querySelector('[data-offer-price]').hidden = !active;
      this.querySelector('[data-offer-calendar]').textContent = active ? '' : Date.now() < this.start ? this.dataset.textBefore : this.dataset.textAfter;
      this.button.disabled = !active || this.busy;
      this.selects.forEach(select => { select.disabled = !active || this.busy; });
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy) return;
      if (!this.isActive()) { this.updateCalendar(); return; }
      if (!this.form.reportValidity()) return;
      const quantities = new Map();
      for (const select of this.selects) {
        const option = select.selectedOptions[0];
        if (!select.value || option.disabled) {
          this.error.textContent = this.dataset.textMissing;
          this.error.focus();
          return;
        }
        quantities.set(select.value, (quantities.get(select.value) || 0) + 1);
      }
      this.busy = true;
      this.button.textContent = this.dataset.textBusy;
      this.error.textContent = '';
      this.form.setAttribute('aria-busy', 'true');
      this.updateCalendar();
      try {
        const items = [...quantities].map(([id, quantity]) => ({ id: Number(id), quantity }));
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items })
        });
        if (!response.ok) {
          this.error.textContent = response.status === 422
            ? 'Izabrana količina trenutno nije dostupna. Proveri korpu, pa izaberi druge dezene.'
            : 'Dodavanje nije uspelo. Proveri korpu pre ponovnog pokušaja.';
          throw new Error('cart_rejected');
        }
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        if (!this.error.textContent) this.error.textContent = 'Veza je prekinuta. Proveri korpu pre ponovnog pokušaja.';
        this.error.focus();
        this.busy = false;
        this.button.textContent = this.dataset.textButton;
        this.form.removeAttribute('aria-busy');
        this.updateCalendar();
      }
    }
  });
}
